// import { logos } from "../../../../config/logos";

// const getLogos = ({
//   variant = "desktop",
//   colorScheme = "light",
// } = {}) =>
//   [...logos]
//     .filter((logo) => logo.visible?.[variant] !== false)
//     .map((logo) => {
//       const isDark =
//         colorScheme === "dark" ||
//         (
//           colorScheme === "system" &&
//           window.matchMedia("(prefers-color-scheme: dark)").matches
//         );

//       return {
//         ...logo,
//         src: isDark
//           ? logo.src.dark
//           : logo.src.light,
//       };
//     })
//     .sort((a, b) => a.priority - b.priority);

// const getLogo = (id) =>
//   logos.find((logo) => logo.id === id);

// export const logosService = {
//   getLogos,
//   getLogo,
// };

import { logos } from "../../../../config/logos";

const resolveLogo = (
  logo,
  {
    colorScheme = "light",
  } = {}
) => {
  if (!logo) {
    return null;
  }

  const isDark =
    colorScheme === "dark" ||
    (
      colorScheme === "system" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    );

  return {
    ...logo,
    src: isDark
      ? logo.src.dark
      : logo.src.light,
  };
};

const getLogos = ({
  variant = "desktop",
  colorScheme = "light",
} = {}) =>
  [...logos]
    // .filter((logo) => logo.visible?.[variant] !== false)
    .filter(
      (logo) =>
        logo.visible?.[variant] !== false &&
        logo.visible?.headerTop !== false
    )
    .map((logo) =>
      resolveLogo(logo, {
        colorScheme,
      })
    )
    .sort((a, b) => a.priority - b.priority);

const getLogo = (
  id,
  {
    colorScheme = "light",
  } = {}
) => {
  const logo = logos.find((logo) => logo.id === id);

  return resolveLogo(logo, {
    colorScheme,
  });
};

export const logosService = {
  getLogos,
  getLogo,
};